export default __webpack_public_path__ + "dim-85940b.json";